import { render } from "./App.vue?vue&type=template&id=79ce94f2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=79ce94f2&lang=scss"

import exportComponent from "/Users/phoebe/projects/find-bus-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__